import {
    importPage,
    importPageFromDir,
} from "@/composables/useRouteImporter.js";

import accountRoutes from "./accountRoutes.js";
import onBoardRoutes from "@/router/onBoardRoutes.js";
import tripRoutes from "./tripRoutes.js";
import checkPermission from "@/middleware/checkPermission.js";
import importRoutes from "./importRoutes.js";
import { checkFeatureFlag } from "@/composables/useFeatureFlag";

// feature flag for listing with gutenberg
const useListingWithBuilder = checkFeatureFlag('VITE_PAGE_LISTING_WITH_BUILDER');

let routes = [
    {
        path: "/login",
        name: "login",
        component: importPageFromDir("Auth", "Login"),
        meta: {
            title: "Login",
            auth: false,
        },
    },
    {
        path: "/register",
        name: "register",
        component: importPageFromDir("Auth", "Register"),
        meta: {
            title: "Register",
            auth: false,
        },
    },
    {
        path: "/forget-password",
        name: "forget-password",
        component: importPageFromDir("Auth", "ForgetPassword"),
        meta: {
            title: "Forget Password",
            auth: false,
        },
    },
    {
        path: "/password-notification",
        name: "password-notification",
        component: importPageFromDir("Auth", "PasswordNotification"),
        meta: {
            title: "Password Reset Successful",
            auth: false,
        },
    },
    {
        path: "/verify-email",
        name: "verify-email",
        component: importPageFromDir("Auth", "VerifyEmail"),
        meta: {
            title: "Verify Email",
            auth: true,
        },
    },
    {
        path: "/account/custom-domain",
        name: "custom-domain",
        component: () => import("../pages/DomainSetting/Index.vue"),
        meta: {
            title: "Custom Domain",
        },
    },
    {
        path: "/dashboard",
        name: "dashboard",
        component: importPage("Dashboard"),
        meta: {
            title: "Dashboard",
            auth: true,
        },
    },


    {
        path: "/domain-setting",
        name: "domain-setting",
        component: importPageFromDir("DomainSetting", "Index"),
        meta: {
            title: "Domain Setting",
            auth: true,
        },
    },
    {
        path: "/app/tools",
        name: "tools",
        component: importPageFromDir("Features", "Index"),
        meta: {
            title: "Tools",
            auth: true,
        },
    },
    {
        path: "/app/cookie-consent",
        name: "cookie-consent",
        component: importPageFromDir("CookieConsent", "Index"),
        meta: {
            title: "Cookie Consent",
            auth: true,
        },
    },

    {
        path: "/app/tools/redirection",
        name: "redirection",
        component: importPageFromDir("Features", "ReDirection"),
        meta: {
            title: "Redirection",
            auth: true,
        },
    },
    {
        path: "/app/tools/custom-scripts",
        name: "custom-scripts",
        component: importPageFromDir("Features", "CustomScript"),
        meta: {
            title: "Custom Script",
            auth: true,
        },
    },
    {
        path: "/app/tools/custom-css",
        name: "custom-css",
        component: importPageFromDir("Features", "CustomCss"),
        meta: {
            title: "Custom Css",
            auth: true,
        },
    },
  
    {
        path: "/app/tools/recaptcha",
        name: "recaptcha",
        component: importPageFromDir("Features", "ReCaptcha"),
        meta: {
            title: "reCaptcha",
            auth: true,
        },
    },
    {
        path: "/app/tools/google-analytics",
        name: "google-analytics",
        component: importPageFromDir("Features", "GoogleAnalytics"),
        meta: {
            title: "Google Analytics 4",
            auth: true,
        },
    },
    {
        path: "/app/tools/altitude-chart",
        name: "altitude-chart",
        component: importPageFromDir("Features", "AltitudeChart"),
        meta: {
            title: "Altitude Chart",
            auth: true,
        },
    },
    {
        path: "/app/tools/itinerary-info",
        name: "itinerary-info",
        component: importPageFromDir("Features", "ItineraryInfo"),
        meta: {
            title: "Itinerary Info",
            auth: true,
        },
    },
    {
        path: "/app/tools/social-sharing",
        name: "social-sharing",
        component: importPageFromDir("Features", "SocialSharing"),
        meta: {
            title: "Social Sharing",
            auth: true,
        },
    },
    {
        path: "/app/tools/notice-bar",
        name: "notice-bar",
        component: importPageFromDir("Features", "NoticeBar"),
        meta: {
            title: "Notice Bar",
            auth: true,
        },
    },

    {
        path: "/checkout",
        name: "checkout",
        component: importPage("Checkout"),
        meta: {
            title: "Checkout",
            auth: true,
        },
    },
    {
        path: "/site/builder",
        name: "editor",
        component: importPageFromDir("Editor", "Index"),
        meta: {
            title: "Editor",
            auth: true,
        },
    },
    {
        path: "/app/payment-gateways",
        name: "payment-gateways",
        component: importPageFromDir("PaymentGateway", "Index"),
        meta: {
            title: "Payment Gateways",
            auth: true,
        },
    },
    {
        path: "/site/navigations",
        name: "navigation",
        component: importPageFromDir("Navigation", "Index"),
        meta: {
            title: "Navigation",
            auth: true,
        },
    },
    {
        path: "/site/navigations/create",
        name: "navigation-create",
        component: importPageFromDir("Navigation", "Create"),
        meta: {
            title: "Navigation",
            auth: true,
        },
    },
    {
        path: "/site/navigations/edit/:slug",
        name: "navigation-update",
        component: importPageFromDir("Navigation", "Edit"),
        meta: {
            title: "Navigation",
            auth: true,
        },
    },
    {
        path: "/app/payment-gateways/configure/:paymentGatewayType",
        name: "payment-gateways-configure",
        component: importPageFromDir("PaymentGateway", "Configure"),
        meta: {
            title: "Payment Gateway Configure",
            auth: true,
        },
    },
    {
        path: "/bookings/all",
        name: "booking-report",
        component: importPageFromDir("Booking", "Index"),
        meta: {
            title: "Booking Report",
        },
    },
    {
        path: "/bookings/create",
        name: "booking-create",
        component: importPageFromDir("Booking", "Create"),
        meta: {
            title: "Add Booking",
        },
    },
    {

        path: "/customers",
        name: "customers",
        component: importPageFromDir("Customers", "Index"),
        meta: {
            title: "Customers",
        },
    },
    {
        path: "/bookings/custom-booking",
        name: "custom-booking",
        component: importPageFromDir("Booking", "CustomBooking"),
        meta: {
            title: "Custom Booking",
        },
    },
    {
        path: "/bookings/custom-booking/:code",
        name: "custom-booking-show",
        component: importPageFromDir("Booking", "CustomBookingShow"),
        meta: {
            title: "Custom Booking Detail",
        },
    },
    {
        path: "/bookings/:slug",
        name: "single-booking-report",
        component: importPageFromDir("Booking", "Show"),
        meta: {
            title: "Booking Report",
        },
    },
    {
        path: "/custom/payment",
        name: "custom-payment",
        component: importPageFromDir("CustomPayment", "Index"),
        meta: {
            title: "Custom Payment",
        },
    },
    {
        path: "/custom/payment/create",
        name: "custom-payment-create",
        component: importPageFromDir("CustomPayment", "Create"),
        meta: {
            title: "Custom Payment",
        },
    },
    {
        path: "/custom/invoices",
        name: "custom-invoices",
        component: importPageFromDir("CustomPayment", "Invoice"),
        meta: {
            title: "Custom Invoices",
        },
    },
    {
        path: "/custom/quick-pay",
        name: "quick-pay",
        component: importPageFromDir("CustomPayment", "QuickPay"),
        meta: {
            title: "Quick Pay",
        },
    },
    {
        path: "/checkout/create",
        name: "checkout-create",
        component: importPageFromDir("Checkout", "Create"),
        meta: {
            title: "Checkout",
        },
    },
    {
        path: "/custom/payment/:code",
        name: "custom-payment-update",
        component: importPageFromDir("CustomPayment", "Create"),
        meta: {
            title: "Custom Payment",
        }
    },
    {
        path: "/bookings/upcoming-tours",
        name: "upcoming-tours",
        component: importPageFromDir("Booking", "UpcomingTours"),
        meta: {
            title: "Upcoming Tours",
        },
    },
    {
        path: "/leads",
        name: "leads",
        component: importPageFromDir("Leads", "Index"),
        meta: {
            title: "Leads",
        },
    },
    {
        path: "/translation",
        name: "translation",
        component: importPageFromDir("Translation", "Index"),
        meta: {
            title: "Translation",
        },
    },
    {
        path: "/payment-unsuccessful",
        name: "payment-unsuccessful",
        component: importPage("PaymentUnsuccessful"),
        meta: {
            title: "Checkout Unsuccessful",
            auth: true,
        },
    },
    {
        path: "/payment-successful",
        name: "payment-successful",
        component: importPage("PaymentSuccessful"),
        meta: {
            title: "Checkout Successful",
            auth: true,
        },
    },
    {
        path: "/pages/all",
        name: "blog-page",
        component: useListingWithBuilder
                ? importPageFromDir("BlogPage", "Index-with-gutenberg")
                : importPageFromDir("BlogPage", "Index"),
        meta: {
            title: "Pages",
            middleware: [checkPermission],
            permissions: ["manage_pages"],
        },
    },
    {
        path: "/pages/create",
        name: "blog-page-create",
        component: importPageFromDir("BlogPage", "Create"),
        meta: {
            title: "Create Page",
            middleware: [checkPermission],
            permissions: ["manage_pages"],
        },
    },
    {
        path: "/pages/edit/:slug",
        name: "update-blog-page",
        component: importPageFromDir("BlogPage", "Create"),
        meta: {
            title: "Update Page",
            middleware: [checkPermission],
            permissions: ["manage_pages"],
        },
    },
    {
        path: "/reusable-blocks/all",
        name: "reusable-block",
        component: importPageFromDir("ReusableBlock", "Index"),
        meta: {
            title: "Reusable Blocks",
            middleware: [checkPermission],
            permissions: ["manage_pages"],
        },
    },
    {
        path: "/reusable-blocks/create",
        name: "reusable-block-create",
        component: importPageFromDir("ReusableBlock", "Create"),
        meta: {
            title: "Reusable Blocks",
            middleware: [checkPermission],
            permissions: ["manage_pages"],
        },
    },
    {
        path: "/reusable-blocks/edit/:slug",
        name: "update-reusable-block",
        component: importPageFromDir("ReusableBlock", "Create"),
        meta: {
            title: "Update Reusable Block",
            middleware: [checkPermission],
            permissions: ["manage_pages"],
        },
    },
    {
        path: "/posts/all",
        name: "post",
        component: importPageFromDir("Post", "Index"),
        meta: {
            title: "Post",
            middleware: [checkPermission],
            permissions: ["manage_posts"],
        },
    },
    {
        path: "/posts/create",
        name: "post-create",
        component: importPageFromDir("Post", "Create"),
        meta: {
            title: "Post",
            middleware: [checkPermission],
            permissions: ["manage_posts"],
        },
    },
    {
        path: "/posts/edit/:slug",
        name: "update-post",
        component: importPageFromDir("Post", "Create"),
        meta: {
            title: "Update Post",
            middleware: [checkPermission],
            permissions: ["manage_posts"],
        },
    },
    {
        path: "/posts/categories",
        name: "post-category",
        component: importPageFromDir("PostCategory", "Index"),
        meta: {
            title: "Post Category",
            middleware: [checkPermission],
            permissions: ["manage_posts"],
        },
    },
    {
        path: "/posts/categories/create",
        name: "post-category-create",
        component: importPageFromDir("PostCategory", "Create"),
        meta: {
            title: "Post Category",
            middleware: [checkPermission],
            permissions: ["manage_posts"],
        },
    },
    {
        path: "/posts/categories/edit/:slug",
        name: "update-post-category",
        component: importPageFromDir("PostCategory", "Update"),
        meta: {
            title: "Update PostCategory",
            middleware: [checkPermission],
            permissions: ["manage_posts"],
        },
    },
    {
        path: "/app/form/builder",
        name: "form",
        component: importPageFromDir("Form", "Index"),
        meta: {
            title: "Form",
        },
    },
    {
        path: "/app/form/builder/create",
        name: "form-create",
        component: importPageFromDir("Form", "Create"),
        meta: {
            title: "Form Create",
        },
    },
    {
        path: "/Customization",
        name: "customization",
        component: importPageFromDir("Customization", "Index"),
        meta: {
            title: "Customization",
        },
    },
    {
        path: "/app/form/builder/:slug/edit",
        name: "form-edit",
        component: importPageFromDir("Form", "Create"),
        meta: {
            title: "Form Edit",
        },
    },
    {
        path: "/app/reviews",
        name: "reviews",
        component: importPageFromDir("Reviews", "Index"),
        meta: {
            title: "Reviews",
        },
    },
    {
        path: "/app/webhooks",
        name: "webhooks",
        component: importPageFromDir("Webhooks", "Index"),
        meta: {
            title: "Webhooks",
            auth: true,
        },
    },
    {
        path: "/app/webhooks/create/",
        name: "create-webhook",
        component: importPageFromDir("Webhooks", "Create"),
        meta: {
            title: "Create Webhook",
            auth: true,
        },
    },
    {
        path: "/app/webhooks/edit/:code",
        name: "edit-webhook",
        component: importPageFromDir("Webhooks", "Create"),
        meta: {
            title: "Edit Webhook",
            auth: true,
        },
    },
    {
        path: "/app/api-keys",
        name: "api-keys",
        component: importPageFromDir("Webhooks", "ApiKeys"),
        meta: {
            title: "API Keys",
            auth: true,
        },
    },
    {
        path: "/:pathMatch(.*)*",
        name: "NotFound",
    },
    {
        name: "forbidden",
        path: "/forbidden",
        component: () => import("@/pages/Errors/403.vue"),
        meta: {
            title: "403 - Forbidden",
            auth: false,
        },
    },
    {
        path: "/my-agencies",
        name: "my-agencies",
        component: importPageFromDir("Agency", "MyAgencies"),
        meta: {
            title: "Agencies",
            auth: true,
        },
    },
    {
        path: "/coupons",
        name: "coupons",
        component: importPageFromDir("Coupons", "Index"),
        meta: {
            title: "Coupons",
            auth: true,
        },
    },
    {
        path: "/coupons/create",
        name: "create-coupon",
        component: importPageFromDir("Coupons", "Create"),
        meta: {
            title: "Create Coupon",
            auth: true,
        },
    },
    {
        path: "/coupons/edit/:id",
        name: "edit-coupon",
        component: importPageFromDir("Coupons", "Create"),
        meta: {
            title: "Update Coupon",
        },
    },
    {
        path: "/travel-insurance/",
        name: "travel-insurance-create",
        component: importPageFromDir("TravelInsurance", "Index"),
        meta: {
            title: "Travel Insurance",
        },
    },
];

routes = [...routes, ...tripRoutes, ...accountRoutes, ...onBoardRoutes, ...importRoutes];

export default routes;
